<div
  class="container-fluid d-flex flex-column justify-content-center align-items-center position-relative overflow-hidden"
  style="min-height: calc(100dvh - 150px);"
  [ngStyle]="{
    'background-image': 'linear-gradient(rgba(255,255,255,0.70), rgba(245,238,255,0.82)), url(' + schoolBackgroundImage + ')',
    'background-size': 'cover',
    'background-position': 'center',
    'background-repeat': 'no-repeat'
  }"
>
  <div class="welcome-box col-12 col-md-8 col-lg-6 text-center position-relative">
    <!-- <img
      src="assets/images/welcome/school.png"
      alt="Welcome Image"
      style="width: 290px; height: 250px; object-fit: contain;"
    /> -->

    <h1 class="fw-bold display-5 mb-3">
      Welcome Back, {{ firstName || 'User' }}!
    </h1>

    <p class="text-secondary mb-4">
      NISHWIK is ready to power your digital journey — from smart payments to seamless services.
    </p>
  </div>
</div>